import { ContainerProps } from '@mui/material';
import { enUS } from '@mui/material/locale';
import {
	Components,
	createTheme,
	Palette,
	PaletteOptions,
	responsiveFontSizes,
	Theme
} from '@mui/material/styles';
import { TypographyOptions } from '@mui/material/styles/createTypography';
import MuiAppBar from './components/MuiAppBar';
import MuiButton from './components/MuiButton';
import MuiTypography from './components/MuiTypography';

import palette from './palette';
import typography from './typography';

interface ThemeOptionsProps {
	components?: Components<Omit<Theme, 'components'>>;
	typography?: TypographyOptions | ((palette: Palette) => TypographyOptions);
	palette: PaletteOptions;
}

interface ThemeProps {
	name: string;
	maxWidth: ContainerProps['maxWidth'];
}

export const THEME: ThemeProps = {
	name: 'WEB_APP',
	maxWidth: 'xl'
};

const ThemeOptions: ThemeOptionsProps = {
	typography,
	palette,
	components: {
		MuiAppBar,
		MuiButton,
		MuiTypography
	}
};

const theme = createTheme(ThemeOptions, { direction: 'ltr' }, enUS);

export const themeWithLanguage = responsiveFontSizes(theme);
export default responsiveFontSizes(theme);
